import { Component } from '@angular/core';

@Component({
  selector: 'fe-reservation-banner',
  templateUrl: './reservation-banner.component.html',
  styleUrls: ['./reservation-banner.component.scss']
})
export class ReservationBannerComponent {

}
